import { createContext, useContext, useEffect, useState } from "react";
import {
  login as loginApi,
  logout as logoutApi,
  getCurrentUser,
} from "../api/authApi";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  /* ===============================
     LOGIN
  ============================== */
  const login = async (credentials) => {
    try {
      const res = await loginApi(credentials);

      // ✅ save logged-in user
      setUser(res.data.user);

    } catch (error) {
      console.error("Login failed:", error);
      setUser(null);
      throw error;
    }
  };

  /* ===============================
     LOGOUT
  ============================== */
  const logout = async () => {
    try {
      await logoutApi();
    } catch (err) {
      // ignore if session already expired
      console.warn("Logout warning:", err);
    }

    setUser(null);
  };

  /* ===============================
     CHECK SESSION
  ============================== */
  const checkSession = async () => {
    try {
      const res = await getCurrentUser();

      // ✅ session valid
      setUser(res.data);

    } catch (err) {
      // session expired or not logged in
      setUser(null);
    }

    setLoading(false);
  };

  useEffect(() => {
    checkSession();
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);